<template>
    <InstalmentPlanComponent ref="installmentComponent"
        v-model:data="InstallmentPlanDataObject"
    ></InstalmentPlanComponent>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { InstalmentPlanComponent } from "nlb-buy-go-library";
import { useInstallmentPlanDataObject } from "@/app/store/app/informative-calculation-component/informative-calc-installment-plan-component";

const { InstallmentPlanDataObject } = useInstallmentPlanDataObject();

const installmentComponent = ref();


async function navigationAction(buttonId: string) {
        const result = await installmentComponent.value?.navigationAction?.(buttonId);
        return result;
    };

    defineExpose({ navigationAction });
</script>